import React from 'react';
import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import styles from './styles/kpiDeltaPill.module.scss';

/**
 * Read-only pill rendered in a KPI tile's action slot to surface a
 * trend delta — green when positive (`up`), red when negative (`down`).
 * Matches the Figma "Fee GL" tab where every tile carries a trend pill
 * (e.g. "+20%", "50.5% CR").
 *
 * Pure presentational. Returns `null` when no delta is supplied so the
 * tile can pass `delta` unconditionally without rendering an empty span.
 *
 * @param {object} props
 * @param {{ value: number, direction: 'up' | 'down', suffix?: string }} props.delta
 */
function KpiDeltaPill({ delta }) {
    if (!delta || typeof delta.value !== 'number') return null;
    const isUp = delta.direction !== 'down';
    const sign = isUp ? '+' : '-';
    const numeric = Math.abs(delta.value);
    const formatted = Number.isInteger(numeric) ? numeric : numeric.toFixed(1);
    const suffix = delta.suffix ? ` ${delta.suffix}` : '';

    return (
        <Text
            as="span"
            size="xs"
            className={mergeClassNames([styles.pill, isUp ? styles.toneUp : styles.toneDown])}>
            {`${sign}${formatted}%${suffix}`}
        </Text>
    );
}

export default KpiDeltaPill;
